import {
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_DETAILS_FAIL,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_FAIL,
  PRODUCT_CREATE_RESET,
  PRODUCT_CREATE_FAIL,
  PRODUCT_CREATE_SUCCESS,
  PRODUCT_CREATE_REQUEST,
  PRODUCT_UPDATE_REQUEST,
  PRODUCT_UPDATE_SUCCESS,
  PRODUCT_UPDATE_FAIL,
  PRODUCT_UPDATE_RESET,
  PRODUCT_CREATE_REVIEW_REQUEST,
  PRODUCT_CREATE_REVIEW_SUCCESS,
  PRODUCT_CREATE_REVIEW_FAIL,
  PRODUCT_CREATE_REVIEW_RESET,
  PRODUCT_TOP_REQUEST,
  PRODUCT_TOP_SUCCESS,
  PRODUCT_TOP_FAIL,
  PRODUCT_IMAGEUPLOAD_REQUEST,
  PRODUCT_IMAGEUPLOAD_SUCCESS,
  PRODUCT_IMAGEUPLOAD_FAIL,
  PRODUCT_IMAGEUPLOAD_RESET,
  PRODUCT_QUICK_IMPORT_REQUEST,
  PRODUCT_QUICK_IMPORT_SUCCESS,
  PRODUCT_QUICK_IMPORT_FAIL,
  PRODUCT_QUICK_IMPORT_RESET,
} from '../constants/productConstants'


export const productListReducer = (state = { products: [] }, action) => {
  switch (action.type) {
    case PRODUCT_LIST_REQUEST:
      return { loading: true, products: [] }
    case PRODUCT_LIST_SUCCESS:
      return {
        loading: false,
        products: (action.payload.products),
        pages: action.payload.pages,
        page: action.payload.page,
      }
    case PRODUCT_LIST_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const productDetailsReducer = (
  state = { product: { reviews: [] } },
  action
) => {
  switch (action.type) {
    case PRODUCT_DETAILS_REQUEST:
      return { ...state, loading: true }
    case PRODUCT_DETAILS_SUCCESS:
      return { loading: false, product: action.payload }
    case PRODUCT_DETAILS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const productDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_DELETE_REQUEST:
      return { loading: true }
    case PRODUCT_DELETE_SUCCESS:
      return { loading: false, success: true }
    case PRODUCT_DELETE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const productCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_CREATE_REQUEST:
      return { loading: true }
    case PRODUCT_CREATE_SUCCESS:
      return { loading: false, success: true, product: action.payload }
    case PRODUCT_CREATE_FAIL:
      return { loading: false, error: action.payload }
    case PRODUCT_CREATE_RESET:
      return {}
    default:
      return state
  }
}

export const productUpdateReducer = (state = { product: {} }, action) => {
  switch (action.type) {
    case PRODUCT_UPDATE_REQUEST:
      return { loading: true }
    case PRODUCT_UPDATE_SUCCESS:
      return { loading: false, success: true, product: action.payload }
    case PRODUCT_UPDATE_FAIL:
      return { loading: false, error: action.payload }
    case PRODUCT_UPDATE_RESET:
      return { product: {} }
    default:
      return state
  }
}
export const productImageUploadReducer = (state = { product: {} }, action) => {
  switch (action.type) {
    case PRODUCT_IMAGEUPLOAD_REQUEST:
      return { loading: true }
    case PRODUCT_IMAGEUPLOAD_SUCCESS:
      return { loading: false, success: action.payload }
    case PRODUCT_IMAGEUPLOAD_FAIL:
      return { loading: false, error: action.payload }
    case PRODUCT_IMAGEUPLOAD_RESET:
      return { product: {} }
    default:
      return state
  }
}

export const productReviewCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_CREATE_REVIEW_REQUEST:
      return { loading: true }
    case PRODUCT_CREATE_REVIEW_SUCCESS:
      return { loading: false, success: true, data: action.payload }
    case PRODUCT_CREATE_REVIEW_FAIL:
      return { loading: false, error: action.payload }
    case PRODUCT_CREATE_REVIEW_RESET:
      return {}
    default:
      return state
  }
}

export const productTopRatedReducer = (state = { products: [] }, action) => {
  switch (action.type) {
    case PRODUCT_TOP_REQUEST:
      return { loading: true, products: [] }
    case PRODUCT_TOP_SUCCESS:
      return { loading: false, products: action.payload }
    case PRODUCT_TOP_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const productQuickImportReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_QUICK_IMPORT_REQUEST:
      return { loading: true }
    case PRODUCT_QUICK_IMPORT_SUCCESS:
      return {
        loading: false,
        success: true,
        product: action.payload.product,
        uploadStats: action.payload.uploadStats,
        production: action.payload.production,
        partialSuccess: action.payload.partialSuccess,
      }
    case PRODUCT_QUICK_IMPORT_FAIL:
      return { loading: false, error: action.payload }
    case PRODUCT_QUICK_IMPORT_RESET:
      return {}
    case 'PRODUCT_PRODUCTION_RETRY_REQUEST':
      return { ...state, productionRetryLoading: true, productionRetryError: null }
    case 'PRODUCT_PRODUCTION_RETRY_SUCCESS':
      return { ...state, productionRetryLoading: false, production: action.payload }
    case 'PRODUCT_PRODUCTION_RETRY_FAIL':
      return { ...state, productionRetryLoading: false, productionRetryError: action.payload }
    default:
      return state
  }
}
